import actionTypes from '../constants/actionTypes'

export default function utils(state = {}, action) {

  let mobileBreakPoint,
    tabletBreakPoint,
    smallDesktopBreakPoint,
    isSmallDevice,
    isTabletDevice,
    isSmallDesktopDevice,
    currentWidth

  switch(action.type) {
    case actionTypes.SET_DEVICE_TYPE:

      currentWidth = action.currentWidth
      mobileBreakPoint = 768
      tabletBreakPoint = [ mobileBreakPoint, 1024 ]
      smallDesktopBreakPoint = [ 1024, 1260 ]
      isSmallDevice = false
      isTabletDevice = false
      isSmallDesktopDevice = false

      if (currentWidth < mobileBreakPoint) {
        isSmallDevice = true
      }

      if (currentWidth > tabletBreakPoint[0] && currentWidth < tabletBreakPoint[1]) {
        isTabletDevice = true
      }

      if (currentWidth > smallDesktopBreakPoint[0] && currentWidth < smallDesktopBreakPoint[1]) {
        isSmallDesktopDevice = true
      }

      return Object.assign({}, state, {
        isSmallDevice,
        isTabletDevice,
        isSmallDesktopDevice
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../app/reducers/utils.js